import React, { useState } from "react";
import SingleSelect, {
  SingleSelectOption
} from "@/components/controls/SingleSelect";
import { cn } from "@/utils/utils";
import { useTranslation } from "react-i18next";

interface EditableSelectCellProps {
  value: string | number | null;
  options: SingleSelectOption[];
  placeholder?: string;
  onValueChange: (value: string | number) => void;
  disabled?: boolean;
  className?: string;
  "data-test"?: string;
}

export const EditableSelectCell: React.FC<EditableSelectCellProps> = ({
  value,
  options,
  placeholder,
  onValueChange,
  disabled = false,
  className,
  "data-test": dataTest
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleSelection = (selectedValue: string | number) => {
    onValueChange(selectedValue);
    setIsOpen(false);
  };

  const handleOpenChange = (open: boolean) => {
    if (!disabled) {
      setIsOpen(open);
    }
  };

  return (
    <div className={cn("w-[120px]", className)} data-test={dataTest}>
      <SingleSelect
        fieldName="editable-select-cell"
        options={options}
        selectedValue={value ?? ""}
        onSelection={handleSelection}
        placeholder={placeholder || t("select")}
        variant="topFields"
        isOpen={isOpen}
        onOpenChange={handleOpenChange}
        disabled={disabled}
        className="w-[120px] border-transparent hover:border-border-field-hover focus:border-border-field-focus"
        showSelectedItemSubtitle={true}
      />
    </div>
  );
};

export default EditableSelectCell;
